import styled from "styled-components";

export const StylesContainerHistory = styled.ul`
  margin: 0;
  padding: 5px;
  max-height: 80vh;
  overflow-y: auto;
  min-width: 250px;
  .attendance-history-item {
    padding: 8px 12px;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #e6edf7;
    }
  }
`;
